<template>
  <Card class="widget-height-md ivu-card-custom" shadow>
    <div slot="title" class="with-icon">
      <h4>Customized Forms Settings</h4>
      <Icon type="ios-add-circle-outline" color="white" size="24" v-show="showAddButton"
            @click.native="$refs.MyQuestionnaireForms.openForm('Create New Form', 'add', allQuestions)"/>
    </div>
    <div class="widget-data full-height">
      <Table :columns="dataColumns" :data="items" class="full-height show-borders initial-height"
             stripe border shadow></Table>
      <Page v-show="showPager" :total="dataCount" :page-size="pageSize"
            show-total show-sizer :page-size-opts="pageSizer" transfer
            @on-change="changeSelectedPage" @on-page-size-change="changePageSize">
      </Page>
      <Spin size="large" fix v-if="spinFormShow"></Spin>
    </div>

    <MyQuestionnaireForms ref="MyQuestionnaireForms"></MyQuestionnaireForms>

    <Modal v-model="confirmDelete" title="CONFIRMATION" @on-ok="remove_SurveyForm(currentDeleteIndex)"
           ok-text="Continue" class-name="vertical-center-modal card-modal" :width="480">
      <div class="confirmation-body">
        <p>
          <Icon type="md-help-circle" size="24" color="#f90"/>
          <span>{{confirmDeleteMessage}}</span></p>
        <p class="submessage">*all associated data will be erased</p>
      </div>
      <div slot="footer">
        <Button class="btn btn-outline-secondary btn-sm" @click="confirmDelete=false">Cancel</Button>
        <Button class="submit btn btn-danger btn-sm" @click="remove_SurveyForm(currentDeleteIndex);confirmDelete=false"
                type="error">Delete
        </Button>
      </div>
    </Modal>

  </Card>
</template>
<script>
  import {deleteForm, getForms, updateForm} from '../../services/Forms.service'
  import MyQuestionnaireForms from './_MyQuestionnaireForms'
  import {bus} from '../../main'

  export default {
    components: {
      MyQuestionnaireForms
    },
    props: ['surveys'],
    data() {
      return {
        showAddButton: false,
        companyName: null,
        eventName: localStorage.getItem('selected_event'),
        spinFormShow: true,
        confirmDelete: false,
        confirmDeleteMessage: '',
        currentDeleteIndex: null,
        dataCount: 0,
        pageSizer: [25, 50, 100],
        pageSize: 25,
        historyData: [],
        showPager: false,
        allQuestions: [],
        dataColumns: [
          {
            title: 'Active',
            key: 'isActive',
            align: 'left',
            minWidth: 100,
            maxWidth: 100,
            visible: false,
            className: 'paddingIndent table-cell-active-custom',
            sortable: true,
            render: (h, params) => {
              if (params.row.isActive == true) {
                return h('Icon', {
                  props: {
                    type: 'ios-checkmark',
                    size: '24'
                  },
                  style: {
                    color: '#fff',
                    backgroundColor: '#35bc44',
                    borderRadius: '5px'
                  },
                  on: {
                    click: () => {
                      params.row.isActive = false;
                      const data = Object.assign({}, params.row);
                      delete data['_index'];
                      delete data['_rowKey'];
                      this.spinFormShow = true;
                      updateForm(params.row.formId, data).then(response => {
                        this.$emit('updateForm', params.row.formId, data);
                        this.getSurveyFormsData();
                      }).catch(error => {
                        this.$Message.error('Failed updating form ' + error);
                      });
                    }
                  }
                })
              } else {
                return h('Icon', {
                  props: {
                    type: 'md-close',
                    size: '24'
                  },
                  style: {
                    color: '#fff',
                    backgroundColor: '#6f6f70',
                    borderRadius: '5px'
                  },
                  on: {
                    click: () => {
                      params.row.isActive = true;
                      const data = Object.assign({}, params.row);
                      delete data['_index'];
                      delete data['_rowKey'];
                      this.spinFormShow = true;
                      updateForm(params.row.formId, data).then(response => {
                        this.$emit('updateForm', params.row.formId, data);
                        this.getSurveyFormsData();
                      }).catch(error => {
                        this.$Message.error('Failed updating form ' + error);
                      })
                    }
                  }
                })
              }
            }
          },
          {
            title: 'Form Name',
            key: 'title',
            align: 'left',
            className: 'paddingIndent',
            sortable: true
          },
          {
            title: 'Form Description',
            key: 'desc',
            align: 'left',
            className: 'paddingIndent',
            sortable: true
          },
          {
            title: 'Content Summary',
            key: 'questions',
            align: 'left',
            className: 'paddingIndent',
            sortable: true,
            render: (h, params) => {
              let title = '';
              if (params.row.questions) {
                let x = params.row.questions.map((data, i) => {
                  title += ((!data.fieldCode) ? data.title.toUpperCase() : data.fieldCode.toUpperCase()) + '\n';
                  let ret = h('span', [h('b', data.title + ' '), h('i', data.type), h('br')]);
                  return ret;
                }, []);
                let result = h('div', {
                  attrs: {
                    title: title
                  }
                }, x);
                return result;

              } else {

                let result = h('span', {attrs: {title: 'No data'}}, 'No data.');
                return result;

              }
            },
          },
          {
            title: 'Action',
            key: 'action',
            align: 'left',
            minWidth: 150,
            maxWidth: 150,
            className: 'paddingIndent',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'ios-eye-outline',
                    size: '24'
                  },
                  on: {
                    click: () => {
                      this.$refs.MyQuestionnaireForms.openForm('VIEW SURVEY FORM', 'view', this.allQuestions);
                      this.$refs.MyQuestionnaireForms.setFormValue(params.row, params.index)
                    }
                  }
                }),
                h('Icon', {
                  props: {
                    type: 'ios-create-outline',
                    size: '24'
                  },
                  on: {
                    click: () => {
                      this.$refs.MyQuestionnaireForms.openForm('UPDATE SURVEY FORM', 'edit', this.allQuestions);
                      this.$refs.MyQuestionnaireForms.setFormValue(params.row, params.index)
                    }
                  }
                }),
                h('Icon', {
                  props: {
                    type: 'ios-close-circle-outline',
                    color: '#9b3035',
                    size: '24'
                  },
                  on: {
                    click: () => {
                      this.confirmDeleteMessage = `Are you sure you want to delete form "${params.row.title}"?`
                      this.confirmDelete = true;
                      this.currentDeleteIndex = params.index;
                    }
                  }
                })
              ]);
            }
          }
        ],
        items: []
      }
    },
    computed: {},
    watch: {
      surveys(surveys) {
        this.setTableData(surveys)
      },
    },
    methods: {
      setTableData(surveys) {
        this.items = surveys;
        this.spinFormShow = false;
      },
      getSurveyFormsData() {
        const self = this;
        self.showPager = false;
        self.showAddButton = false;
        self.items = [];
        self.spinFormShow = true;

        let companies = JSON.parse(localStorage.getItem('companies'));
        if (companies) {
          let company = companies.filter(a => a.companyId == localStorage.getItem('selected_company'));
          if (company.length > 0) {

            let eventsList = JSON.parse(localStorage.getItem('events'));
            if (eventsList) {

              let event = eventsList.filter(a => a.eventId == localStorage.getItem('selected_event'));
              if (event.length > 0) {

                self.companyName = company[0].companyName;
                self.eventName = event[0].eventName;
                let companyId = company[0].companyId;
                let eventId = event[0].eventId;

                getForms(false, true, companyId).then(response => {
                  let result = response.data.filter(x => x.isSurveyForm == true);
                  if (eventId) {
                    result = result.filter(x => x.eventId == eventId);
                  }
                  result.sort((a, b) => (a.isActive < b.isActive) ? 1 : ((b.isActive < a.isActive) ? -1 : 0));
                  self.items = result;

                  self.historyData = self.items;
                  self.allQuestions = [];
                  self.historyData.map(i => {
                    if (i.questions) {
                      let data_ = {
                        formId: i.formId,
                        formName: i.title,
                        questions: i.questions
                      };
                      self.allQuestions.push(data_);
                    }
                  });
                  self.dataCount = self.items.length;
                  if (self.historyData.length < self.pageSize) {
                    self.items = self.historyData;
                  } else {
                    self.items = self.historyData.slice(0, self.pageSize);
                  }
                  if (self.items.length > 0) {
                    self.showPager = true;
                  }
                  self.spinFormShow = false;
                  self.showAddButton = true;
                }, []);
              } else {
                self.showPager = false;
                self.spinFormShow = false;
              }
            } else {
              self.showPager = false;
              self.spinFormShow = false;
            }
          } else {
            self.showPager = false;
            self.spinFormShow = false;
          }
        } else {
          self.showPager = false;
          self.spinFormShow = false;
        }
      },
      showSpin() {
        this.spinFormShow = true
      },
      remove_SurveyForm(index) {
        deleteForm(this.items[index].formId, true).then(response => {
          if (response.data == 'Form cannot be deleted because it is being used!') {
            this.$Message.error('Form cannot be deleted because it is being used!');
          } else {
            this.items.splice(index, 1);
            this.$Message.success('Form successfully deleted!');
          }
        }).catch(error => {
          this.$Message.error('Failed deleting form');
        })
      },
      changePageSize(size) {
        this.pageSize = size;
        this.changeSelectedPage(1);
      },
      changeSelectedPage(index) {
        let _start = (index - 1) * this.pageSize;
        let _end = index * this.pageSize;
        this.items = this.historyData.slice(_start, _end);
      }
    },
    created() {
      this.spinFormShow = true;
      this.getSurveyFormsData();
    },
    mounted() {
      bus.$on('changeSurveyForm', (eventName, companyName) => {
        this.eventName = eventName;
        this.companyName = companyName;
        this.getSurveyFormsData();
      });
    },
  }
</script>
<style scoped>
  .ivu-card-custom {
    overflow: auto;
    height: auto;
  }

  .ivu-table table tbody tr td {
    vertical-align: top;
    padding-top: 5px;
  }

  .ivu-table-wrapper:not(.show-borders) .ivu-table table tbody tr:last-of-type td {
    vertical-align: top;
    padding-top: 5px;
  }

  .ivu-table td {
    height: 80px;
  }

  .ivu-table .table-cell-custom {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ivu-table-cell .ivu-poptip,
  .ivu-table-cell .ivu-table-sort {
    position: absolute;
    right: auto;
  }

  .ivu-table-cell td, .ivu-table-cell th {
    border: 0;
    height: 20px;
    line-height: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/d_MyQuestionnaireForms/_MyQuestionnaire.vue